import PropTypes from 'prop-types';
import React from 'react';
import {repairInternet} from 'src/shared/pagePaths';
import {button} from 'src/styles/modules/button.module.scss';
import DeflectionCall from 'src/svgs/scheduleCallback/DeflectionCall.svg';
import {DeflectionInternet} from 'src/svgs/scheduleCallback/DeflectionInternet';
import {header} from '../header.module.scss';
import {
  icons,
  interstitialButton,
  interstitialCard,
  interstitialHeader,
  recommended,
  suggestionText,
} from '../interstitial.module.scss';

export const InternetInterstitialView = ({
  onGetCall,
  onInternetRepair,
}) => (
  <>
    <header className={header}>
      <h1>We can help with that</h1>
      <p>We found some common solutions to try first, or you can schedule a call below.</p>
    </header>

    <div className={interstitialCard}>
      <div className={interstitialHeader}>
        <DeflectionInternet className={icons} />
        <p>Restart Modem<br /><span className={recommended}>Recommended</span></p>
        <a className={`${button} ${interstitialButton}`} href={repairInternet()} onClick={onInternetRepair}>Troubleshoot</a>
      </div>
      <hr />
      <div className={suggestionText}>
        <p>Restarting your modem fixes most common issues and will help diagnose the problem if you need more help.</p>
        <p>You&apos;ll use the same tools our agents use to troubleshoot on the phone.</p>
      </div>
    </div>

    <div className={interstitialCard}>
      <div className={interstitialHeader}>
        <DeflectionCall className={icons} />
        <p>I&apos;d like to speak with an agent</p>
        <button className={`${button} ${interstitialButton}`} onClick={onGetCall}>Get a Call</button>
      </div>
    </div>
  </>
);

InternetInterstitialView.propTypes = {
  onGetCall: PropTypes.func.isRequired,
  onInternetRepair: PropTypes.func.isRequired,
};
